import React, { useState, useEffect } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { saveAs } from 'file-saver';
// import '../styles.css';
import moment from 'moment';
import { Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify';
import Loader from '../../shared/common/loader';
import useRazorpay, { RazorpayOptions } from 'react-razorpay';
import SipHttp from './sip.service';

import {
  addThousandSeparators,
  formatAmount,
  getTransactionType,
} from '../../utils';
import { useHistory } from 'react-router-dom';
import {
  BUYBACK_INVOICE_APPROVAL_MESSAGE,
  BUYBACK_INVOICE_UPLOAD_MESSAGE,
  INCOMPLETE_BUYBACK_INVOICE,
  INCOMPLETE_SELL_INVOICE,
  PAYMENT_PENDING_MESSAGE,
} from 'constants/messages.constant';
import { userStore } from 'store/UserStore';
import BuySellService from '../../services/buy-sell.service';

interface PropsType {
  handleModal: any;
  isShow: boolean;
  data: any;
  displaySummary: boolean;
  emandates?: string;
  sipMethod?: string;
}

const SipSummary: React.FC<PropsType> = ({
  handleModal,
  isShow,
  data,
  displaySummary,
  emandates,
  sipMethod,
}) => {
  const [loading, setLoading] = useState<any>(false);
  const [message, setMessage] = useState('');
  const Razorpay = useRazorpay();
  const [customerId, setUser, user, selectedAccount] = userStore(
    (state: any) => [
      state.customerId,
      state.setUser,
      state.user,
      state.selectedAccount,
    ]
  );
  const [razorpay, setRazorpay] = useState<any>({
    customerId: customerId,
    amount: null,
    paymentMethod: 'NEBK',
  });

  let history = useHistory();

  const checkPaymentStatus = async (paymentId, orderId) => {
    try {
      let payload = {
        paymentId,
        orderId,
      };
      setLoading(true);
      //   const res = await BuySellService.checkPaymentStatus(payload, '');
    } catch (error) {
    } finally {
      toast.success('Successful');
      setLoading(false);
      handleModal(false);
      // history.push('/sip');
    }
  };

  const onSuccessRpyMandate = async () => {
    handleModal(false);
    // history.push('/sip');
    const toastMessage = encodeURIComponent(
      'E-mandate request has been send successfully'
    );
    window.location.href = `${process.env.REACT_APP_BASE_URL}/sip?tab=sippassbook&toastMessage=${toastMessage}`;
    // setTimeout(() => {
    //   toast.success('E-mandate request has been send successfully');
    // }, 1000);
  };

  const onFailureRpyMandate = async () => {
    handleModal(false);
    // history.push('/sip');
    history.push('/sip');

    setTimeout(() => {
      toast.error('Payment Failed');
    }, 1000);
  };
  /**
   * Download invoice pdf
   */
  const setInitialStateRazorpay = () => {
    setRazorpay({
      customer_id: '',
      order_id: '',
    });
  };
  /**
   * Download order summary pdf
   */

  const placeOrder = async () => {
    try {
      if (emandates == 'withoutMandate' || sipMethod == 'paymanual') {
        setLoading(true);
        const resp = await SipHttp.createSIPWithoutEM(customerId, data);
        if (resp?.status == 200) {
          setTimeout(() => {
            toast.success('SIP created successfully');
          }, 1000);
          setLoading(false);

          handleModal(false);
          history.push('/sip?tab=sippassbook');
        }
      } else {
        let resp;
        if (emandates == 'withMandateUPI') {
          resp = await SipHttp.createSIPWithEM(customerId, user?.userId, true,data?.frequency);
        } else {
          resp = await SipHttp.createSIPWithEM(customerId, user?.userId, false,data?.frequency);
        }
        handleModal(false);
        if (resp?.status == 200) {
          await authFunc(resp?.data?.data);
        }
      }
    } catch (err) {
      toast.error('Something Went Wrong');
      setLoading(false);

      console.log(err);
    }
  };
  const authFunc = async (rpyData) => {
    // const resp1 = await SipHttp.createSIPWithEM(customerId);
    // console.log(resp1?.data.data, 'resp1111');
    const { rpyOrderId, rpyCustomerId } = rpyData;
    let redirect_url: any;
    const options: any = {
      key: process.env.REACT_APP_RAZORPAY_KEY,

      //   amount: (data?.installment_amt * 100).toString(),

      name: 'eBullion',
      description: 'Create SIP',
      image:
        'https://ebullion-dev.s3.ap-south-1.amazonaws.com/assets/eb-logo.png',
      // order_id: resp1?.data?.data?.rpyOrderId,
      order_id: rpyOrderId,
      customer_id: rpyCustomerId,
      recurring: 1,
      // callback_method: 'get',
      // callback_url: 'https://secure.ebullion.in/sip',
      handler: async (response: any) => {
        setLoading(true);
        if (response.razorpay_payment_id) {
          await onSuccessRpyMandate();
          // redirect_url = 'http://secure.ebullion.in/sip';
        } else {
          await onFailureRpyMandate();

          // redirect_url = 'http://secure.ebullion.in/sip';
        }
        // location.href = redirect_url;

        // const payload = {
        //   customerId: razorpay.customerId,
        //   razorpayOrderId: response.razorpay_order_id,
        //   razorpayPaymentId: response.razorpay_payment_id,
        //   razorpaySignature: response.razorpay_signature,
        // };
        //     // const res: any =
        //     //   paymentMethod === 'UPI'
        //     //     ? await BuySellService.verifyUPIPaymentRazorpay(payload)
        //     //     : await BuySellService.verifyNEBKPaymentRazorpay(payload);
        //     // if (res.status === 200 && res.data.data) {
        //     // setInitialStateRazorpay();
        //     // await checkPaymentStatus(
        //     //   response.razorpay_payment_id,
        //     //   data?.ebOrderRef
        //     // );
        //     // }

        setInitialStateRazorpay();
        // onSuccessRpyMandate();
        // await checkPaymentStatus(
        //   response.razorpay_payment_id,
        //   response.razorpay_order_id
        // );
      },
      prefill: {
        name: user.displayName,
        email: user.email.value,
        contact: user.mobile.value,
      },
      notes: {
        ...data,
      },
      theme: {
        hide_topbar: false,
        color: '#141034',
        backdrop_color: 'rgba(0, 0, 0, 0.90)',
      },
      // redirect: true,‹
      // timeout: 180,
    };
    // const options = data;

    // options.order_id = rpyOrderId;
    //   razorpay.amount = data?.installment_amt;
    //   options.amount = (razorpay.amount * 100).toString();
    const razorPay = new Razorpay(options);

    razorPay.open();
  };

  return (
    <>
      {loading && <Loader />}
      {data && (
        <>
          <Modal
            show={isShow}
            onHide={() => handleModal(false)}
            // bsPrefix='md__'
            dialogClassName=''
          >
            <Modal.Header closeButton>
              <Modal.Title>Plan Details</Modal.Title>
            </Modal.Header>
            <Modal.Body className='px-5'>
              <div className='row py-3 justify-content-between border-bottom'>
                {/* <div className='col-md-6 mb-2'>Order Status</div>
                  <div className='col-md-6  mb-2 text-end'>
                    <div className='badge bg-secondary'>
                      <b>{data.status}</b>
                    </div>
                  </div> */}
                <div className='col-md-6 col-6 mb-3'>Start Date</div>
                <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                  <div className='badge bg-secondary'>
                    <b> {moment(data?.start_date).format('DD-MMM-yyyy')}</b>
                  </div>
                </div>
                <div className='col-md-6 col-6 mb-3'>Duration</div>
                {/* <div className='col-md-6 mb-2 text-end'> */}
                <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                  <b>{data?.duration} Months</b>
                </div>
                <div className='col-md-6 col-6 mb-3'>Frequency</div>
                {/* <div className='col-md-6 mb-2 text-end'> */}
                <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                  <b>{data?.frequency?.toUpperCase()}</b>
                </div>
                <div className='col-md-6 col-6 mb-3'>
                  {data?.installment_amt ? 'Amount' : 'Grams'}
                </div>
                {/* <div className='col-md-6 mb-2 text-end'> */}
                <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                  <b>
                    {data?.installment_amt
                      ? `₹${data?.installment_amt}`
                      : `${data?.grams}g`}
                  </b>
                </div>
                <div className='col-md-6 col-6 mb-3'>Payment Method</div>
                {/* <div className='col-md-6 mb-2 text-end'> */}
                <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                  {sipMethod == 'paymanual' ? (
                    <b>PAY MANUAL</b>
                  ) : (
                    <b>E-MANDATE</b>
                  )}
                </div>
                {sipMethod !== 'paymanual' && (
                  <>
                    <div className='col-md-6 col-6 mb-3'>E-Mandate Status</div>
                    {/* <div className='col-md-6 mb-2 text-end'> */}
                    <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                      <b>{data?.bank == '' ? 'PENDING' : 'CONFIRMED'}</b>
                    </div>
                  </>
                )}
              </div>
              <div className='d-grid py-3'>
                <Button
                  variant='primary'
                  className='btn-block'
                  onClick={(e) => placeOrder()}
                  size='lg'
                >
                  Authenticate
                </Button>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
    </>
  );
};

export default SipSummary;
